<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      <p>&copy; 2026 <a href="/" class="footer-link">gbofficial.net</a> - Independent guides about GB WhatsApp. Not affiliated with Meta or WhatsApp. All trademarks belong to their owners.</p>
    </div>
    <div class="footer-links">
      <router-link to="/privacy/" class="footer-link">Privacy</router-link>
      <span aria-hidden="true">|</span>
      <router-link to="/about-us/" class="footer-link">About Us</router-link>
      <span aria-hidden="true">|</span>
      <router-link to="/disclaimer/" class="footer-link">Disclaimer</router-link>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  // Avoid vue/no-reserved-component-names for the native footer element.
  name: 'SiteFooter',
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
}
@media (max-width: 768px) {
  .footer {
    padding: 10px 0 50px;
  }
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.footer-links {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
}

.footer-links .footer-link,
.footer-links span {
  font-size: 12px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  width: 100%;
  font-size: 15px;
  text-align: center;

  p {
    margin: 0;
    white-space: nowrap;
  }
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    width: 90%;
    gap: 8px;
  }

  .footer-links {
    justify-content: center;
    width: 100%;
    margin-bottom: 0;
  }

  .footer-note {
    width: 100%;
    font-size: 10px;

    p {
      white-space: normal;
    }
  }
}
</style>
